<template>
    <base-table :key="tick" class="table align-items-center table-flush"
                tbody-classes="list"
                :data="userlocations">
        <template slot="columns">
            <th>Zugriff auf folgende Standort</th> <!---- todo tooltip für operatoren beachten ---->
            <th class="text-right">
                <base-dropdown position="right" v-if="!isLoading">
                    <base-button slot="title" icon="ni ni-fat-add" size="sm" class="dropdown-toggle"></base-button>
                    <a v-for="loc in locations" :key="'loc'+loc.id" class="dropdown-item align-right" href="#" @click="addLocUser(loc['@id'],uid)">{{loc.name}} hinzufügen</a>
                </base-dropdown>
            </th>
        </template>
        <template slot-scope="{row,index}">
            <th v-if="isLoading" scope="row" >
                <div class="loading"> </div>
            </th>
            <th v-else scope="row" v-html="row.location.name">
            </th>
            <td>
                <div v-if="isLoading" class="loading-button"> </div><div v-else>
                <base-button v-if="!row.delete" type="primary" icon="far fa-trash-alt" size="sm" v-on:click="deleteConfirmation(index)"></base-button>
                <div v-if="row.delete" style="margin-top: 1rem;"><span  class="text-danger">Sicher? <i class="far fa-trash-alt"></i></span><br>
                    <base-button v-if="row.delete" size="sm" type="danger" icon="fas fa-check" v-on:click="deleteUserLocation(row.id)">Ja</base-button>
                    <base-button v-if="row.delete" size="sm" type="info" icon="fas fa-times" v-on:click="deleteConfirmation(index)">Nein</base-button>
                </div>
            </div>
            </td>
        </template>
    </base-table>
</template>

<script>
    export default {
        name:"UserLocations",
        props: {
            uid: {
                type: String,
            },
            customer: {
                type: String,
            }
        },
        data() {
            return {
                userlocations: [],
                isLoading: true,
                tick: 21321
            }
        },
        created() {
            this.init();
        },
        computed: {
            locations() {
                return (this.$store.getters['customer/isReady']) ? this.$store.getters['customer/showCustomerByIRI'](this.customer).locations : [];
            }
        },
        methods: {
            init() {
                this.$store.dispatch('customer/getCustomerCollection');
                this.getUserLocations(this.uid).then(data =>{
                    this.userlocations = data.member;
                    this.isLoading = false;
                    this.tick++;
                })
                    .catch(err => {
                        this.$store.dispatch('alert/error',err);
                        this.isLoading = false;
                        this.tick++;
                    })
            },
            getUserLocations(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users/`+id+`/user_locations?pagination=false`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve({
                                    totalItems: response['hydra:totalItems'],
                                    member: response['hydra:member']
                                });
                            },
                            error => {
                                reject(error);
                            });
                });
            },
            addLocUser(lid,uid) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = {
                        user: '/api/users/'+uid,
                        location: lid
                    };
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/user_locations`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.$store.dispatch('alert/success','Standort hinzugefügt.');
                                this.getUserLocations(uid).then(response => {
                                    this.userlocations = response.member;
                                    this.isLoading = false;
                                    this.tick++;
                                });
                            },
                            error => {
                                reject(error);
                                this.$store.dispatch('alert/error',error);
                                this.isLoading = false;
                                this.tick++;
                            });
                });
            },
            deleteUserLocation(id) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'DELETE',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/user_locations/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                                this.getUserLocations(this.uid).then(response => {
                                    this.userlocations = response.member;
                                    this.$store.dispatch('alert/success','Standort gelöscht');
                                    this.isLoading = false;
                                    this.tick++;
                                });

                            },
                            error => {
                                reject(error);
                                this.isLoading = false;
                                this.$store.dispatch('alert/error',error);
                                this.tick++;
                            });
                });
            },
            deleteConfirmation(index) {
                if(typeof this.userlocations[index].delete === "undefined") {
                    this.userlocations[index].delete = false;
                }
                this.userlocations[index].delete = !this.userlocations[index].delete;
                this.tick++;
            },
        }
    }
</script>

<style scoped>

</style>